import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getDataStatus, getFormData, getFormVariables, getSummaryData } from "./apiController";
import { ArrowLeftOutlined } from "@ant-design/icons";
import CustomTable from "../../widgets/table";
import MasterData from "./MasterData";
import { useDispatch, useSelector } from "react-redux";
import { authSelector, setLoading } from "../../store/slices/auth";
import UidAddDataModal from "./UidAddDataModal";
import ViewForm from "./ViewForm";
import { cloneDeep } from "lodash";
import SurveyFormComponent from "../surveyForm/SurveyFormComponent";

function DataEntryStatus() {
     let locationState = useLocation();
     const [projectData, setProjectData] = useState<any>({});
     const [statusData, setStatusData] = useState([]);
     const [columns, setColumns] = useState<any>([]);
     const [records, setrecords] = useState<any>([]);
     const [recordsData, setrecordData] = useState<any>([]);
     const navigate = useNavigate();
     const [action, setaction] = useState<any | "">("");
     const dispatch = useDispatch();
     const [masterData, setmasterData] = useState<any>([]);
     const [masterId, setmasterId] = useState<any>("");
     const [masterFormId, setmasterFormId] = useState<any>("");
     const [selectedIndex, SetselectedIndex] = useState<any>({});
     const [selectedRecords, SetSelectedRecords] = useState<any>("");
     const [selectedRow, setselectedRow] = useState<any | null>(null);
     const [formData, setformData] = useState<any>([]);
     const [formVariables, setformVariables] = useState<any | []>([]);
     const [permissionData, setPermissionData] = useState({});
     const projectDataPerm = useSelector(authSelector)
     const [customNavigationState, setCustomNavigationState] = useState<any>({});

     useEffect(() => {
          let temp: any = locationState.state;
          console.log(temp)
          setProjectData(temp)
          fetchInitialData();
     }, [])

     useEffect(() => {
          let temp: any = locationState.state;

          // Filter `projectPermissionData` from `projectDataPerm` to find the permissions
          // related to the current project based on its ID.
          let perData = projectDataPerm.projectPermissionData?.filter(itm => itm.projectId == temp.id);

          // Initialize an empty object to store permissions.
          let permArray = {};

          // If permissions data (`perData`) exists and contains at least one item, 
          // process its `permissionData`.
          perData && perData[0]?.permissionData.forEach((obj) => {

               // If the current permission object has a key "Data":
               if (Object.keys(obj)[0] == "Data") {
                    // Iterate over each item in the "Data" array.
                    obj[Object.keys(obj)[0]].forEach((objItem) => {
                         // Map the `action` to its corresponding "allowed" permission's `is_selected` value.
                         permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected;
                    });

                    // Uncommented line here could be used to set the "Data" permissions if needed.
                    // setPermission(obj[Object.keys(obj)[0]]);

                    // If the current permission object has a key "Forms":
               } else if (Object.keys(obj)[0] == "Forms") {
                    // Iterate over each item in the "Forms" array.
                    obj[Object.keys(obj)[0]].forEach((objItem) => {
                         // Map the `action` to its corresponding "allowed" permission's `is_selected` value.
                         permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected;
                    });
               }
          });

          // Set the processed permission data into the state using `setPermissionData`.
          setPermissionData(permArray);




     }, []); // Dependency array is empty, so this effect runs only once when the component mounts.


     /**
      * filter data locally
      */
     const filterData = (data, filterData, page) => {
          console.log(data, records)

          if (data.search_data.length == 0) {
               fetchInitialData()
          } else {
               const filtered: any = data.search_data.length > 0 && recordsData.filter(item =>
                    item[data.search_data[0].field_id]
                         ?.toLowerCase()
                         .includes(data.search_data[0].search_value)
               );
               setrecords(filtered)
          }
     }

     /**
      * fetch initial data
      */
     const fetchInitialData = async () => {
          try {
               let temp: any = locationState.state;
               let response = await getDataStatus(temp.TopicID);
               let allRows = response && response.data ? response.data : [];

               if (!Array.isArray(allRows) || allRows.length === 0) return;

               // --- 1. Gather unique column ids and labels ---
               // Always have the master column first
               const masterColumnId = allRows[0].master_response_field_id;
               let columns = [{
                    id: masterColumnId,
                    label: "Master Data Id",
                    data: { id: masterColumnId },
                    accessor: masterColumnId,
               }];

               // Collect unique forms for column headers
               let formIdSet = new Set<string>();
               let formDefinitions: Record<string, any> = {};

               // Find all unique forms (in any row)
               for (let row of allRows) {
                    if (!row.all_responses) continue;
                    for (let form of row.all_responses) {
                         if (!formIdSet.has(form.form_id)) {
                              formIdSet.add(form.form_id);
                              // cache the definition for label/data
                              formDefinitions[form.form_id] = form;
                         }
                    }
               }

               // Add columns for each unique form_id
               Array.from(formIdSet).forEach(form_id => {
                    const form = formDefinitions[form_id];
                    columns.push({
                         id: form_id,
                         label: form.form_name,
                         data: form, // this can carry extra data if needed
                         accessor: form_id,
                    });
               });

               // --- 2. Prepare data rows ---
               let data: any = [];
               for (let row of allRows) {
                    let dataRow: any = {};
                    // master id column
                    dataRow[masterColumnId] = row.master_response_id;
                    // all form columns in this row
                    if (row.all_responses) {
                         for (let form of row.all_responses) {
                              // Each column's accessor is the form_id. The value is count_info.
                              dataRow[form.form_id] = form.count_info;
                         }
                    }
                    data.push(dataRow);
               }

               setColumns(columns);
               setrecords(data);
               setrecordData(data);

               if (allRows[0].master_response_field_id) setmasterId(allRows[0].master_response_field_id);
               if (allRows[0].master_form_id) setmasterFormId(allRows[0].master_form_id);

          } catch (error) {
               // handle error as needed
               console.error(error);
          }
     };


     /**
    * 
    * @param type 
    * @param data 
    * onClick to handle each action on viewdata
    */
     const onAction = async (type, data: any = null, i: any = null) => {
          switch (type) {
               case "master":
                    console.log(data)
                    SetselectedIndex(data)
                    setaction('adduid')
                    break;
               case "navigateToDataEntry":
                    setCustomNavigationState(data);
                    setaction(type);
                    break;
               default:
                    setaction(type);
                    break;
          }
     }

     /**
        * get form summary data
        * id and form id
        */
     const getSummaryForm = async (data) => {
          // let uidData = data.uidData;
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
          let dataParams = [
               {
                    "field_id": masterId,
                    "search_value": records[selectedIndex.id][masterId],
                    "field_type": "textBox",
                    "time_zone": tz
               }
          ]
          try {
               dispatch(setLoading(true))
               let response = await getSummaryData(data.TopicID, masterFormId, dataParams);
               if (response) {
                    console.log(response)

                    setaction('addData')
                    setmasterData(response.data)
                    dispatch(setLoading(false))
               } else {

               }
          } catch (error) {
               dispatch(setLoading(false))
          }

     }

     const onAddMaster = () => {
          let temp: any = locationState.state;
          getSummaryForm(temp)
     }


     /**
      * on modify data
      */
     const onModify = async (record, index: any = null) => {
          try {
               let responseForm = await getFormData(record.form_id);
               if (responseForm) {
                    let dataCurObj = responseForm.data;
                    dataCurObj.isMaster = true;
                    dataCurObj.masterData = masterData;
                    dataCurObj.projectData = projectData;

                    console.log(responseForm)
                    // navigate('/dataEntry', { state: { data: dataCurObj, projectData: projectData, selectedValues: record.record_info[index].fields, id: record.record_info[index].id, isMaster: true, moduleType: "dataEntry" } });
                    const state = { data: dataCurObj, projectData: projectData, selectedValues: record.record_info[index].fields, id: record.record_info[index].id, isMaster: true, moduleType: "dataEntry" };
                    onAction("navigateToDataEntry", state);
               }
          } catch (error) {

          }
     }

     /**
      * on add master action
      */
     const onAddAction = (formitm) => {
          console.log(formitm, selectedIndex)
          let data: any = {
               form_name: formitm.form_name,
               id: formitm.form_id,
          };

          data.projectData = projectData;
          data.isMaster = true;
          data.masterData = masterData;
          console.log(data)
          // navigate('/dataEntry', { state: { data, projectData: projectData, isMaster: true, moduleType: "dataEntry" } });
          const state = { data, projectData: projectData, isMaster: true, moduleType: "dataEntry" };
          onAction("navigateToDataEntry", state);
     }

     /**
        * on view action
        */
     const onViewAction = async (record, index) => {
          console.log(record, index)
          setselectedRow(record.record_info[index])
          let responseForm = await getFormData(record?.form_id);
          setformData(responseForm?.data);
          let response = await getFormVariables(record?.form_id);
          if (response.data && response.data.length > 0) {
               // response.data.forEach((obj) => {
               //      let selectedRecord = responseData[data.index].fields.filter(elem => elem.id === obj.id);
               //      if (selectedRecord.length > 0) {
               //           if (obj.field_type === 'dateField') {
               //                obj.selectedValue = new Date(selectedRecord[0].field_selected_value);
               //           } else if (obj.field_type === 'dropDown') {
               //                obj.selectedValue = {
               //                     label: selectedRecord[0].field_selected_value,
               //                     value: selectedRecord[0].field_selected_value
               //                };
               //           } else {
               //                obj.selectedValue = selectedRecord[0].field_selected_value;
               //           }
               //      }
               //      obj.field_category = obj.field_category || 'empty';
               // });
               // let temp: any = _.groupBy(response.data, "field_category");
               // if (temp.empty) {
               //      let data = cloneDeep(temp.empty);
               //      delete temp.empty;
               //      temp.empty = data;
               // }
               setformVariables(response.data);
               setaction('view');
          }
     }



     return (
          <>
               {
                    action === 'navigateToDataEntry' &&
                    <SurveyFormComponent {...customNavigationState} onClose={() => setaction('')} />
               }


               {
                    action == 'adduid' &&
                    <UidAddDataModal onAdd={onAddMaster} projectData={projectData} variables={[]} onClose={() => setaction('')} />
               }
               {
                    action === 'view' ?
                         <ViewForm projectData={projectData} selectedRecord={selectedRow} variables={formVariables} formData={formData} permissionData={permissionData} modify={onModify} onClose={() => setaction('')} />
                         :
                         action == "addData" ?
                              <MasterData projectData={projectData} mdata={masterData} addAction={onAddAction} onModify={onModify} onAction={onViewAction} onClose={() => setaction('')} id={masterFormId} />
                              :
                              <div className="data-status-container">
                                   <div className='pt-2 actions-header'>
                                        <div className='actions-text'>
                                             {
                                                  window.innerWidth > 700 ?
                                                       <ArrowLeftOutlined style={{ color: "#fff", fontSize: "28px", margin: "0px 10px" }} onClick={() => navigate(window.innerWidth > 700 ? '/project' : '/projectmobile')} />
                                                       : ""
                                             }
                                             {projectData && projectData?.TopicDesc || projectData?.topicdesc}
                                        </div>
                                   </div>
                                   <div className="data-status-body">
                                        <CustomTable
                                             header="Records"
                                             data={records && records}
                                             tableProps={columns && columns}
                                             isPushToDoc={false}
                                             isCustomFilter={true}
                                             isFilter={false}
                                             isEdit={false}
                                             isView={false}
                                             isDelete={false}
                                             isCreate={false}
                                             isSearch={false}
                                             getFilteredData={filterData}
                                             indexNo={0}
                                             isMaster={true}
                                             formId={"id"}
                                             onAction={(type, data = null) => onAction(type, data)}
                                        >
                                        </CustomTable>
                                   </div>
                              </div>
               }
          </>
     )
}

export default DataEntryStatus;